import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=3c54a7b1&"
import script from "./ProductEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports